import { SERVER_API_PATH, reportApiError, serverApi } from "api/api-server-actions";

export async function serverIngestTopic(courseId: string, file: File): Promise<void> {
  try {
    const formData = new FormData();
    formData.append("course_id", courseId);
    formData.append("file", file);
    await serverApi.post(`${SERVER_API_PATH}/ingestion/ingestions/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    reportApiError("serverIngestTopic", error);
    throw error;
  }
}
